import { RootState } from "../types";

export const adminSelector = (state: RootState) => state.user.admin;
// export const usersSelector = (state: RootState) => state.user.admin.users;
// export const hosenUsersSelector = (state: RootState) =>
//   state.user.admin.hosenUsers;
// export const hosenUsersWithRecommendationsSelector = (state: RootState) =>
//   state.user.admin.hosenUsersWithRecommendations;
// export const therapistsSelector = (state: RootState) =>
//   state.user.admin.therapists;
export const RRMListSelector = (state: RootState) => state.user.RRMList;

// Multi-company selectors
export const MultyCompaniesListSelector = (state: RootState) => state.user.admin.usersMultipleCompanies;
export const isMultiCompanySelector = (state: RootState) => 
  (state.user.admin.usersMultipleCompanies?.length ?? 0) > 1;
export const selectedCompanySelector = (state: RootState) => state.user.admin.selectedCompany;
